import api from './api';
import { DashboardData, TypeClient } from '../types';

export const dashboardService = {
  get: (typeClient?: TypeClient) =>
    api.get<DashboardData>('/api/dashboard', { params: typeClient ? { typeClient } : undefined }).then((r) => r.data),
  getByPeriode: (debut: string, fin: string, typeClient?: TypeClient) =>
    api.get<DashboardData>('/api/dashboard/periode', {
      params: typeClient ? { debut, fin, typeClient } : { debut, fin },
    }).then((r) => r.data),
};
